<template>
  <section  @click="stopShow($event)" style="display: inherit" class="multipleSelectFather">
    <section :style="{'max-width': width ? width + '!important' : '','min-width': width ? width + '!important' : ''}" class="multipleSelect">
      <section>
        <section :style="{'cursor':newDisabled? ' no-drop': 'pointer'}" :title="placeholder" @click="needSearchShowDropFun" v-if="showSelectValue === ''" style="color: #ccc;" class="multipleSelectShowPlace">
          <section>{{placeholder}}</section>
        </section>
        <section :style="{'cursor':newDisabled? ' no-drop': 'pointer'}" :title="showSelectValue" v-else @click="needSearchShowDropFun" class="multipleSelectShowPlace">
          <section class="NoWrap">{{showSelectValue}}</section>
        </section>
      </section>
      <section :id="randomId + '-cover'" style="display: none" class="selectCover"></section>
      <section :id="randomId" class="multipleSelectDrop">
        <!-- <section class="multipleSelectDropTitle textcenter">
          <section @click="cancelData" style="width: 40px;text-align: right">取消</section>
          <section class="f_w t_c" style="width: calc(100% - 90px)">{{title || '请选择'}}</section>
          <section @click="clickConfirm" style="width: 40px">确定</section>
        </section> -->
        <section style="overflow-y:auto; height: calc(100% - 50px); padding: 30px 20px;">
          <section class="fields-box boxarea" style="position: relative;">
            <div class="closeBtn"  @click="cancelData">
              <!-- <i class="icon iconfont iconguanbi" style="color: #EF1201;"></i> -->
              <i class="icon iconfont iconguanbi2" style="color: #EF1201;"></i>
            </div>
            <div class="boxarea-title">感兴趣的领域</div>
            <ul class="boxarea-list">
              <!-- 暂时加此判断 隐藏心脑血管及代谢领域  display:(item.id == 13 || item.id == 61) ? 'none' : '' -->
              <li :class="{'activeItem': item.checked}" :style="[{width:item.name.length > 9 ? '96%': '', display:(item.id == 13 || item.id == 61) ? 'none' : ''}]" v-for="(item, index) in fieldList" :key="index" @click="chooseFields(item, index)">
                <span
                :class="{'field-icon':true,
                'vessels': (item.id == 13 || item.id == 61) && !item.checked,
                'digestion': (item.id == 11 || item.id == 1) && !item.checked,
                'rare-diseases': (item.id == 14 || item.id == 121) && !item.checked,
                'tumor': (item.id == 12 || item.id == 31) && !item.checked,
                'blood': (item.id == 15 || item.id == 91) && !item.checked,
                'other': (item.id == 21 || item.id == 151) && !item.checked,
                'vessels-active': (item.id == 13 || item.id == 61) && item.checked,
                'digestion-active': (item.id == 11 || item.id == 1) && item.checked,
                'rare-diseases-active': (item.id == 14 || item.id == 121) && item.checked,
                'tumor-active': (item.id == 12 || item.id == 31) && item.checked,
                'blood-active': (item.id == 15 || item.id == 91) && item.checked,
                'other-active': (item.id == 21 || item.id == 151) && item.checked}">
                </span>
                <span style="display: inline;">{{item.name}}</span>
              </li>
            </ul>
          </section>
          <section class="indications-box boxarea" v-show="showIndicationList">
            <div class="boxarea-title">感兴趣的适应症</div>
            <ul class="boxarea-list" style="max-height: 38vh;">
              <!-- 暂时加此判断 隐藏心脑血管及代谢领域的适应症 display:(item.fieldId == 13 || item.fieldId == 61) ? 'none' : '' -->
              <li :class="{'activeItem': item.checked}" :style="[{width:item.name.length > 9 ? '96%': '', display:(item.fieldId == 13 || item.fieldId == 61) ? 'none' : ''}]" v-for="(item, index) in indicationList" :key="index" @click="chooseIndications(item, index)">
                <span
                :class="{'field-icon':true,
                'vessels': (item.fieldId == 13 || item.fieldId == 61) && !item.checked,
                'digestion': (item.fieldId == 11 || item.fieldId == 1) && !item.checked,
                'rare-diseases': (item.fieldId == 14 || item.fieldId == 121) && !item.checked,
                'tumor': (item.fieldId == 12 || item.fieldId == 31) && !item.checked,
                'blood': (item.fieldId == 15 || item.fieldId == 91) && !item.checked,
                'other': (item.fieldId == 21 || item.fieldId == 151) && !item.checked,
                'vessels-active': (item.fieldId == 13 || item.fieldId == 61) && item.checked,
                'digestion-active': (item.fieldId == 11 || item.fieldId == 1) && item.checked,
                'rare-diseases-active': (item.fieldId == 14 || item.fieldId == 121) && item.checked,
                'tumor-active': (item.fieldId == 12 || item.fieldId == 31) && item.checked,
                'blood-active': (item.fieldId == 15 || item.fieldId == 91) && item.checked,
                'other-active': (item.fieldId == 21 || item.fieldId == 151) && item.checked}">
                </span>
                <span style="display: inline;">{{item.name}}</span>
              </li>
            </ul>
          </section>
          <div class="bottom-btn">
            <div class="confirm-btn" @click="confirmSelected">
              <span>确定</span>
            </div>
          </div>
        </section>
      </section>
    </section>
  </section>
</template>

<script>
let timeOut
let array = []
export default {
  name: 'cander',
  model: {
    prop: 'selectValue',
    event: 'selectValue'
  },
  props: [
    'multiple',
    'directPick',
    'selectValue',
    'chooseData',
    'needReturn',
    'showValue',
    'needOther',
    'matchValue',
    'placeholder',
    'width',
    'disabled',
    'item',
    'title',
    'textArea',
    'coverF',
    'fieldList',
    'indicationList',
    'getAllIndicationList',
    'getSelectedIndication',
    'update'
  ],
  data () {
    return {
      chooseValue: '',
      other: false,
      shownothing: false,
      statusTextArea: this.textArea || '',
      newneedOther: this.needOther || '',
      newDisabled: this.disabled,
      randomId: 'selectId' + new Date().getTime() + Math.random() * 1000,
      newSelectValue: this.selectValue,
      searchValue: '',
      showSelectValue: '',
      selectData: this.chooseData,
      originalFieldList: [],
      originalIndicationList: [],
      showIndicationList: false
    }
  },
  created () { // vue 页面的生命周期 当我一进来页面之后 我先执行
    array = []
    this.showSelectValue = this.selectValue
    this.originalFieldList = JSON.parse(JSON.stringify(this.fieldList))
    this.originalIndicationList = JSON.parse(JSON.stringify(this.indicationList))
  },
  mounted () { // vue 页面的生命周期 当我进来之后 且加载完资源了之后再执行
  },
  destroyed () {
  },
  methods: {
    searchList (e) {
      let multipleSelectSelectData = document.getElementById(this.randomId).querySelectorAll('.multipleSelectSelectData')
      for (let i = 0; i < multipleSelectSelectData.length; i++) {
        multipleSelectSelectData[i].style.display = 'none'
        if (multipleSelectSelectData[i].innerHTML.indexOf(e.target.value) >= 0 || multipleSelectSelectData[i].innerHTML.indexOf('其它') >= 0) {
          multipleSelectSelectData[i].style.display = 'block'
        }
      }
    },
    // 解决ios输入框失去焦点时不能回滚到顶部的问题
    kickBack () {
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollTop + 1)
        document.body.scrollTop >= 1 && window.scrollTo(0, document.body.scrollTop - 1)
        if (document.getElementById('scorllNowPlace')) {
          window.scrollTo(0, document.getElementById('scorllNowPlace').scrollTop + 1)
          document.getElementById('scorllNowPlace').scrollTop >= 1 && window.scrollTo(0, document.getElementById('scorllNowPlace').scrollTop - 1)
        }
      }, 10)
    },
    clickConfirm () {
      let dom = document.getElementById(this.randomId)
      let domCover = document.getElementById(this.randomId + '-cover')
      dom.style.top = '100%'
      setTimeout(p => {
        dom.style.display = 'none'
        domCover.style.display = 'none'
      }, 200)
      this.$emit('textAreaValue', this.statusTextArea)
      this.$emit('on-confirm', '')
      if (this.other) {
        this.newSelectValue = this.statusTextArea
        this.showSelectValue = this.statusTextArea
        this.$emit('selectValue', this.newSelectValue)
      }
    },
    cancelData () {
      this.$emit('recoverFieldList', this.originalFieldList)
      this.$emit('recoverIndicationList', this.originalIndicationList)
      let selectedField = this.originalFieldList.filter(val => val.checked)
      let selectedFieldIds = selectedField.map(val => val.id)
      let selectedIndication = this.originalIndicationList.filter(val => val.checked)
      let selectedIndicationIds = selectedIndication.map(val => val.id)
      // 重新获取适应症
      this.$emit('getAllIndicationList', selectedFieldIds, selectedField)
      // 选中的适应症
      this.$emit('getSelectedIndication', selectedIndicationIds, selectedIndication)

      let dom = document.getElementById(this.randomId)
      let domCover = document.getElementById(this.randomId + '-cover')
      dom.style.top = '100%'
      setTimeout(p => {
        dom.style.display = 'none'
        domCover.style.display = 'none'
      }, 200)
      // this.$emit('selectValue', this.chooseValue)
    },
    searchValueFun (e) {
      clearTimeout(timeOut)
      timeOut = setTimeout(p => {
        let searchValue = e.target.value
        let selDom = document.getElementById(this.randomId)
        let selList = selDom.querySelectorAll('.multipleSelectSelectData')
        let num = 0
        for (let i = 0; i < selList.length; i++) {
          if (searchValue === '') {
            selList[i].style.display = 'block'
          } else {
            selList[i].style.display = 'none'
            if (selList[i].innerHTML.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0) {
              selList[i].style.display = 'block'
            }
          }
          if (selList[i].style.display !== 'none') {
            num++
          }
        }
        if (num === 0) {
          this.shownothing = true
        } else {
          this.shownothing = false
        }
      }, 500)
    },
    backAllList () {
      let selDom = document.getElementById(this.randomId)
      let selList = selDom.querySelectorAll('.multipleSelectSelectData')
      for (let i = 0; i < selList.length; i++) {
        selList[i].style.display = 'block'
      }
      this.shownothing = false
    },
    handleData () {
      this.showSelectValue = ''
      let splitValue = (this.newSelectValue === '' || this.newSelectValue === null || this.newSelectValue === undefined) ? [''] : this.newSelectValue.toString().split(',')
      if (this.selectData) {
        for (let i = 0; i < this.selectData.length; i++) {
          this.$set(this.selectData[i], 'checked', false)
          for (let j = 0; j < splitValue.length; j++) {
            if (this.selectData[i][this.needReturn].toString() === splitValue[j]) {
              // if (this.multiple) {
              //   this.selectData[i].checked = true
              // }
              this.selectData[i].checked = true
              this.showSelectValue += this.selectData[i][this.matchValue] + ','
            }
          }
        }
      }
      this.showSelectValue = this.showSelectValue.substring(0, this.showSelectValue.length - 1)
      if (this.selectValue && !this.showSelectValue) {
        this.showSelectValue = this.selectValue
        this.statusTextArea = this.showSelectValue
        for (let i = 0; i < this.selectData.length; i++) {
          if (this.selectData[i][this.needReturn].toString() === '其它' && this.needOther) {
            this.selectData[i].checked = true
          }
        }
      }
      console.log(this.selectValue, 'showValue')
      let html = this.showValue
      // getItem(html)
    },
    confirmData (item) {
      // this.multiple
      if (this.multiple) {
        let splitValue = (this.newSelectValue === '' || this.newSelectValue === null || this.newSelectValue === undefined) ? [''] : this.newSelectValue.split(',')
        console.log(splitValue)
        let splitshowSelectValue = this.showSelectValue === '' ? [] : this.showSelectValue.split(',')
        if (item[this.needReturn].toString() === '' && splitValue.length > 0) {
          splitValue = ['']
        }
        if (splitValue.indexOf(item[this.needReturn].toString()) >= 0) {
          splitValue.splice(splitValue.indexOf(item[this.needReturn].toString()), 1)
          splitshowSelectValue.splice(splitshowSelectValue.indexOf(item[this.needReturn].toString()), 1)
          let selectHmtl = ''
          let selectHmtl2 = ''
          for (let i = 0; i < splitValue.length; i++) {
            selectHmtl += splitValue[i] + ','
            selectHmtl2 += splitshowSelectValue[i] + ','
          }
          selectHmtl = selectHmtl.substring(0, selectHmtl.length - 1)
          selectHmtl2 = selectHmtl2.substring(0, selectHmtl2.length - 1)
          this.newSelectValue = selectHmtl
          this.showSelectValue = selectHmtl2
          this.$emit('selectValue', this.newSelectValue)
          if (this.item) {
            item.object = this.item
          }
          this.$emit('on-change', item)
        } else {
          if (this.newSelectValue === '') {
            this.newSelectValue += item[this.needReturn]
          } else {
            this.newSelectValue += ',' + item[this.needReturn]
          }
          this.$emit('selectValue', this.newSelectValue)
          if (this.item) {
            item.object = this.item
          }
          this.$emit('on-change', item)
          if (this.showSelectValue === '') {
            this.showSelectValue += item[this.matchValue]
          } else {
            this.showSelectValue += ',' + item[this.matchValue]
          }
        }
        this.handleData()
      } else {
        if (item[this.needReturn] === '其它' && this.needOther) {
          this.other = true
        } else {
          this.other = false
          this.statusTextArea = ''
        }
        this.newSelectValue = item[this.needReturn]
        this.showSelectValue = item[this.matchValue]
        console.log(this.newSelectValue)
        this.$emit('selectValue', this.newSelectValue)
        if (this.item) {
          item.object = this.item
        }
        this.$emit('on-change', item)
        // let dom = document.getElementById(this.randomId)
        // dom.style.opacity = '0'
        // setTimeout(p => {
        //   dom.style.display = 'none'
        // }, 200)
      }
      if (this.directPick) {
        this.clickConfirm()
      }
    },
    needSearchShowDropFun () {
      this.originalFieldList = JSON.parse(JSON.stringify(this.fieldList))
      this.originalIndicationList = JSON.parse(JSON.stringify(this.indicationList))
      let selectedField = this.originalFieldList.filter(val => val.checked)
      let selectedFieldIds = selectedField.map(val => val.id)
      let selectedIndication = this.originalIndicationList.filter(val => val.checked)
      let selectedIndicationIds = selectedIndication.map(val => val.id)
      // 判断是否有选中的区域，如果没有则隐藏适应症区域
      this.checkSelectedField (selectedField)

      console.log('needSearchShowDropFun')
      if (!this.newDisabled) {
        this.backAllList()
        let dom = document.getElementById(this.randomId)
        let domCover = document.getElementById(this.randomId + '-cover')
        let domList = document.querySelectorAll('.multipleSelectFather')
        for (let i = 0; i < domList.length; i++) {
          // domList[i].style.zIndex = 1
        }
        // dom.parentNode.parentNode.style.zIndex = 2
        if (dom.style.display === 'none' || dom.style.display === '') {
          dom.style.display = 'block'
          domCover.style.display = 'block'
          setTimeout(p => {
            dom.style.top = '15%'
          }, 10)
        }
      }
    },
    showDropFun () {
      console.log('showDropFun')
      if (!this.newDisabled) {
        this.chooseValue = this.selectValue
        let dom = document.getElementById(this.randomId)
        let domCover = document.getElementById(this.randomId + '-cover')
        if (dom.style.display === 'none' || dom.style.display === '') {
          dom.style.display = 'block'
          domCover.style.display = 'block'
          setTimeout(p => {
            dom.style.top = '30%'
          }, 10)
        } else {
          dom.style.top = '100%'
          setTimeout(p => {
            dom.style.display = 'none'
            domCover.style.display = 'none'
          }, 200)
        }
      }
    },
    returnShowValue (object) {
      let html = this.showValue
      for (let i = 0; i < array.length; i++) {
        html = html.replace('{{' + array[i] + '}}', object[array[i]])
      }
      return html
    },
    stopShow (e) {
      e.stopPropagation()
    },
    chooseFields (item, index) {
      if (this.multiple) {
        item.checked = !item.checked
      } else {
        for (let i = 0; i < this.fieldList.length; i++) {
          if (i == index) {
            this.fieldList[i].checked = true
          } else {
             this.fieldList[i].checked = false
          }
        }
      }
      let choosedItems = this.fieldList.filter(item => item.checked)
      let choosedIds = choosedItems.map(val => val.id)
      // 重新获取适应症
      this.$emit('getAllIndicationList', choosedIds, choosedItems)
      // 判断是否有选中的区域，如果没有则隐藏适应症区域
      this.checkSelectedField (choosedItems)
    },
    chooseIndications (item, index) {
      if (this.multiple) {
        item.checked = !item.checked
      } else {
        for (let i = 0; i < this.indicationList.length; i++) {
          if (i == index) {
            this.indicationList[i].checked = true
          } else {
             this.indicationList[i].checked = false
          }
        }
      }
      let choosedItems = this.indicationList.filter(item => item.checked)
      let choosedIds = choosedItems.map(val => val.id)
      // 选中的适应症
      this.$emit('getSelectedIndication', choosedIds, choosedItems)
    },
    confirmSelected () {
      this.originalFieldList = JSON.parse(JSON.stringify(this.fieldList))
      this.originalIndicationList = JSON.parse(JSON.stringify(this.indicationList))

      let dom = document.getElementById(this.randomId)
      let domCover = document.getElementById(this.randomId + '-cover')
      dom.style.top = '100%'
      setTimeout(p => {
        dom.style.display = 'none'
        domCover.style.display = 'none'
      }, 200)
    },
    checkSelectedField (list) {
      // 暂时加此判断 隐藏心脑血管及代谢领域的适应症
      let flag = list.every(val => val.id == 13 || val.id == 61)
      if (list.length > 0 && !flag) {
        this.showIndicationList = true
      } else {
        this.showIndicationList = false
        this.$emit('recoverIndicationList', [])
      }
    }
  },
  watch: {
    textArea (value) {
      this.statusTextArea = value
    },
    selectValue (value) {
      // this.newSelectValue = value
      // this.showSelectValue = ''
      // this.handleData()
      this.showSelectValue = value
      console.log(value, 'selectValue---change')
    },
    fieldList (newData) {
      console.log(newData, 'watch--------------fieldList')
      let choosedItems = newData.filter(item => item.checked)
      let choosedIds = choosedItems.map(val => val.id)
      // console.log(choosedItems, 'choosedItems')
      // 重新获取适应症
      this.$emit('getAllIndicationList', choosedIds, choosedItems)
      // 判断是否有选中的区域，如果没有则隐藏适应症区域
      this.checkSelectedField (choosedItems)
    },
    indicationList (newData) {
      let choosedItems = newData.filter(item => item.checked)
      let choosedIds = choosedItems.map(val => val.id)
      // 选中的适应症
      this.$emit('getSelectedIndication', choosedIds, choosedItems)
    }
  },
  computed: {
  }
}
function getItem (html) {
  if (html.indexOf('{{') >= 0) {
    let aPos = html.indexOf('{{')
    let bPos = html.indexOf('}}')
    let newName = html.substr(aPos + 2, bPos - aPos - 2)
    array.push(newName)
    html = html.replace('{{', '').replace('}}', '')
    getItem(html)
  }
}
</script>

<style scoped>
  .selectCover{
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    transition: all 0.3s;
    left: 0;
    opacity: 1;
    z-index: 1000;
    background: rgba(0, 0, 0, 0.5);
  }
  .multipleSelectFather{
    position: relative;
    display: inline-block;
    width: 100%;
  }
  .multipleSelect{
    display: inline-block;
    position: relative;
    text-align: left;
    /*z-index: 5;*/
  }
  .multipleSelect .multipleSelectShowPlace {
    background-color: #fff;
    text-align: left;
    cursor: pointer;
    font-size: 16px;
    /*white-space: nowrap;*/
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .backWhite .multipleSelect .multipleSelectShowPlace {
    background-color: transparent!important;
  }
  .multipleSelect .multipleSelectDrop .multipleSelectDropTitle {
    padding: 10px 0;
    border-bottom: 1px solid #eee;
  }
  .multipleSelect .multipleSelectDrop .multipleSelectDropTitle > section{
    display: inline-block;
  }
  .multipleSelect .multipleSelectDrop {
    position: fixed;
    top: 100%;
    left: 0;
    background: #fff;
    right: 0;
    display: none;
    transition: top 0.2s;
    bottom: 0;
    z-index: 1001;
    /* overflow: auto; */
    box-shadow: 0px 0px 5px 0px #ccc;
    border-radius: 4px;
  }
  .multipleSelect .multipleSelectDrop .multipleSelectSelectData{
    padding: 15px 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    position: relative;
  }
  .multipleSelect .multipleSelectDrop .multipleSelectSelectData.active::after{
    content: '√';
    font-family: "微软雅黑", "Arial";
    position: absolute;
    right: 18px;
    width: 16px;
    height: 16px;
    border-radius: 20px;
    background: #ee1100;
    color: #fff;
    line-height: 12px;
    text-align: center;
    top: 16px;
  }
  .multipleSelect .multipleSelectDrop .multipleSelectSelectData.active p{
    display: block;
  }
  .multipleSelect .multipleSelectDrop .multipleSelectSelectData p{
    display: none;
  }
  /*.multipleSelect .multipleSelectDrop .multipleSelectSelectData.active {*/
  /*  color: #C50F3C;*/
  /*}*/
  .multipleSelect .multipleSelectDrop .multipleSelectSelectData:hover{
    /*color: #fff;*/
    cursor: pointer;
    background: #f1f1f1;
  }
  .multipleSelectArror{
    position: absolute;
    right: 8px;
    top: 9px;
    color: #666;
    /*font-size: 10px;*/
  }
  /*@media screen and (max-width: 1370px) {*/
  /*  .multipleSelect {*/
  /*    max-width: 200px!important;*/
  /*    min-width: 200px!important;*/
  /*  }*/
  /*}*/
  .boxarea {
    width: 100%;
    /* padding: 5px 10px; */
    border-radius: 6px;
    background-color: #F7F7F7;
    box-sizing: border-box;
  }
  .boxarea-title {
    text-align: center;
    border-bottom: 1px solid #D0D0D0;
    height: 30px;
    line-height: 30px;
  }
  .indications-box {
    margin-top: 30px;
    margin-bottom: 57px;
  }
  .boxarea-list {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    text-align: center;
    max-height: 178px;
    overflow-y: auto;
  }
  .boxarea-list li {
    /* width: 42%; */
    min-width: 46%;
    max-width: 96%;
    /* height: 40px; */
    height: auto;
    /* line-height: 40px; */
    border-radius: 4px;
    text-align: left;
    background-color: #ffffff;
    margin: 2%;
    float: left;
    font-size: 12px;
    padding: 10px 5px;
    box-sizing: border-box;
  }
  .boxarea-list li.activeItem {
    background-color: #EF1201;
    color: #ffffff;
  }
  .boxarea-list li span {
    display: inline-block;
  }
  .boxarea-list li span.field-icon {
    width: 15px;
    height: 15px;
  }
  /* 心血管及代谢 */
  .vessels {
    background: #ffffff url('../../assets/vessels.png') no-repeat center center;
    background-size: contain;
  }
  .vessels-active {
    background: #EF1201 url('../../assets/vessels-active.png') no-repeat center center;
    background-size: contain;
  }
  /* 消化 */
  .digestion {
    background: #ffffff url('../../assets/digestion.png') no-repeat center center;
    background-size: contain;
  }
  .digestion-active {
    background: #EF1201 url('../../assets/digestion-active.png') no-repeat center center;
    background-size: contain;
  }
  /* 罕见病 */
  .rare-diseases {
    background: #ffffff url('../../assets/rare-diseases.png') no-repeat center center;
    background-size: contain;
  }
  .rare-diseases-active {
    background: #EF1201 url('../../assets/rare-diseases-active.png') no-repeat center center;
    background-size: contain;
  }
  /* 肿瘤 */
  .tumor {
    background: #ffffff url('../../assets/tumor.png') no-repeat center center;
    background-size: contain;
  }
  .tumor-active {
    background: #EF1201 url('../../assets/tumor-active.png') no-repeat center center;
    background-size: contain;
  }
  /* 血液制品 */
  .blood {
    background: #ffffff url('../../assets/blood.png') no-repeat center center;
    background-size: contain;
  }
  .blood-active {
    background: #EF1201 url('../../assets/blood-active.png') no-repeat center center;
    background-size: contain;
  }
  /* 其他 */
  .other {
    background: #ffffff url('../../assets/other.png') no-repeat center center;
    background-size: contain;
  }
  .other-active {
    background: #EF1201 url('../../assets/other-active.png') no-repeat center center;
    background-size: contain;
  }
  .closeBtn {
    position: absolute;
    top: -16px;
    right: -8px;
    width: 30px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border-radius: 50%;
    background-color: #ffffff;
    /* border: 2px solid #EF1201; */
    z-index: 1001;
  }
  .closeBtn i {
    /* font-weight: 700; */
    font-size: 32px!important;
    color: #EF1201;
    /* line-height: 18px; */
  }
  .bottom-btn {
    width: 100%;
    text-align: center;
    margin: 0 auto;
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: #ffffff;
    padding: 10px 20px;
    box-sizing: border-box;
  }
  .bottom-btn .confirm-btn {
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: #EF1201;
    color: #ffffff;
    border-radius: 4px;
    box-shadow: 2px 2px 8px #C5C5C5;
  }
  .bottom-btn .cancle-btn {
    width: 40%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: #ffffff;
    color: #333333;
    border-radius: 4px;
    border: 1px solid #C5C5C5;
    box-shadow: 2px 2px 8px #C5C5C5;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/fieldSelect.vue